import { Settings } from '@framework/types/response/Settings'
import { get } from '@framework/api/axios'

export const fetchSettings = async (): Promise<Settings> => {
  const res = await get<Settings>(`/api/settings`)
  // todo handle error
  // todo add type guard?
  return res
}
